
export enum ServiceCd {
	DEFERRED = 'Deferred',
	NORMAL_LTL = 'NormalLtl'}

